import { render, staticRenderFns } from "./InputDropDownButton.vue?vue&type=template&id=2ba87ade&"
import script from "./InputDropDownButton.vue?vue&type=script&lang=js&"
export * from "./InputDropDownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports